import React from "react";
import { Container, Typography, Box } from "@mui/material";

const Disclaimer = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Disclaimer
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last Updated: April 2026
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography paragraph>
          Kundlistar provides astrology services including KP astrology, BNN Nadi,
          Nadi astrology, and Vedic astrology. All predictions and reports are based
          on traditional calculations and interpretative methods.
        </Typography>

        <Typography paragraph>
          Astrology is not an exact science. We do not guarantee the accuracy or
          reliability of predictions. Results may vary for each individual.
        </Typography>

        <Typography paragraph>
          The information provided is for guidance purposes only and should not be
          considered as professional advice, including financial, medical, or legal advice.
        </Typography>

        <Typography paragraph>
          Users are advised to consult qualified professionals before making important decisions.
        </Typography>

        <Typography paragraph>
          Kundlistar is not responsible for any decisions or outcomes resulting from the use of our services.
        </Typography>
      </Box>
    </Container>
  );
};

export default Disclaimer;